import { Button } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import { loadingButtonStyles } from './styles'

type Props = {
  text: string
  isLoading: boolean
  disabled: boolean
  isSubmission?: boolean
}
export const LoadingButton = ({ isLoading, text, disabled, isSubmission }: Props) => (
  <Button fullWidth={!isSubmission} variant={'contained'} type={'submit'} disabled={disabled}>
    {!isLoading ? text : <CircularProgress sx={loadingButtonStyles.loading} size={24} />}
  </Button>
)
